import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {SelectItem, SelectItemGroup} from "primeng/api";
import {UserManagementService} from "../../../../services/apiServices/business/user-management.service";
import {AuthenticationService} from "../../../../services/apiServices/security/authentication.service";
import {User} from "../../../../model/user";
import {combineLatest} from "rxjs";
import {TranslateService} from "@ngx-translate/core";
import {ConsultCriteriaService} from "../../../../services/apiServices/business/consult-criteria.service";
import {SearchService} from "../../../../services/apiServices/business/search.service";
import {AppParameterService} from "../../../../services/apiServices/business/app-parameter.service";
import {TreatmentChainService} from "../../../../services/apiServices/business/treatment-chain.service";
import {CommonService} from "../../../../services/apiServices/business/common.service";

@Component({
  selector: 'app-impersonation',
  templateUrl: './impersonation.component.html',
  styleUrls: ['./impersonation.component.css']
})
export class ImpersonationComponent implements OnInit {
  @Output() userImpersonated: EventEmitter<boolean>;

  usersLoaded = false;
  customerGroupsAndUsers: SelectItemGroup[];
  impersonationSubject: string;
  isAdminNumen = false;
  impersonated = false;
  impersonatedConfLoding = false;


  constructor(private userManagementService: UserManagementService, private authenticationService: AuthenticationService,
              private translate: TranslateService, private consultService:ConsultCriteriaService, private searchService: SearchService,
              private appParameterService:AppParameterService, private treatmentChainService: TreatmentChainService,
              private commonService : CommonService  ) {
    this.userImpersonated = new EventEmitter();
  }
  ngOnInit(): void {
    this.initImpersonation();
  }

  public initImpersonation(): void {
    this.isAdminNumen = this.authenticationService.isAdminNumen();
    this.impersonated = this.authenticationService.isImpersonnated();
    if (this.isAdminNumen) {
      this.loadUserList();
    }
    else {
      this.customerGroupsAndUsers = [];
    }
  }


  public loadUserList(): void {
    this.userManagementService.getCustomerUsers().subscribe(rusers => {
      this.customerGroupsAndUsers = [];
      // tslint:disable-next-line:forin
      for (const key in rusers) {
        const items: SelectItem[] = [];
        for (const item of rusers[key]) {
          items.push({label: item.sUserFirstName + ' ' + item.sUserLastName + ' [' + item.sUserID + ']', value: item.sUserID});
        }
        this.customerGroupsAndUsers.push({
          label: key,
          items: items
        });
      }
      setTimeout(() => {
        this.impersonationSubject = null;
        this.usersLoaded = true;
      }, 500);
    });
  }

  public impersonate(): void {
    const subject = new User();
    subject.idCustomer = this.authenticationService.getCurrentUser().idCustomer;
    subject.idUser = this.impersonationSubject;
    const sub = combineLatest(
        this.authenticationService.documentExtData,
        this.consultService.exposedCriterias,
        this.searchService.exposedCriterias,
        this.appParameterService.parametersReady,
        this.treatmentChainService.chainsReady
    );
    sub.subscribe( ([extData, sc, cc, param, chains]) => {
      this.impersonatedConfLoding = false;
    });
    this.authenticationService.impersonate(subject).subscribe(successful => {
      if (!successful) {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.translate.instant('COMMON.IMPERSONATION_FAILURE_TITLE'),
          detail: this.translate.instant('COMMON.IMPERSONATION_FAILURE_MSG')
        });
      }
      else {
        this.initImpersonation();
        this.impersonatedConfLoding = true;
        this.userImpersonated.emit(true);
      }
    });
  }



}
